import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from '@redux/rootReducer';

const initializeStore = (preloadedState = {}) =>
  createStore(rootReducer(), preloadedState, composeWithDevTools(applyMiddleware()));

export default initializeStore;
